import { Avatar, Box, TextareaAutosize } from "@mui/material";
import React, { useEffect } from "react";
import Footer from "../component/Footer";
import Navbar from "../component/Navbar";
import LockClockOutlined from "@mui/icons-material/LockClockOutlined";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const validationSchema = yup.object({
  name: yup.string().min(3).required("Company name ir required!"),
  location: yup.string().min(3).required("Location is required!!"),
  description: yup.string().min(5).required("description is required!"),
});

const CreateCompany = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const { isAuthenticated, userInfo } = useSelector((state) => state.signIn);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const formik = useFormik({
    initialValues: {
      name: "",
      location: "",
      description: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values, actions) => {
      console.log(values);
      //dispatch(userSignInAction(values));
      actions.resetForm();
    },
  });

  return (
    <>
      <Box
        sx={{
          height: "81vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          onSubmit={formik.handleSubmit}
          component="form"
          className="form_style border-style"
          sx={{ width: "350px" }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: "primary.main", mb: 3 }}>
              <LockClockOutlined />
            </Avatar>
            <TextField
              sx={{ mb: 3 }}
              fullWidth
              id="name"
              label="name"
              name="name"
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
            />
            <TextField
              sx={{ mb: 3 }}
              fullWidth
              label="Location"
              name="location"
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="location"
              value={formik.values.location}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.location && Boolean(formik.errors.location)}
              helperText={formik.touched.location && formik.errors.location}
            />
            <TextField
              sx={{ mb: 3 }}
              fullWidth
              id="description"
              name="description"
              label="description"
              type="description"
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="description"
              value={formik.values.description}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.description && Boolean(formik.errors.description)
              }
              helperText={
                formik.touched.description && formik.errors.description
              }
            />
            <Button fullWidth variant="contained" type="submit">
              create Company
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default CreateCompany;
